import { useEffect, useState, useMemo } from 'react';
import { useAsyncCallback } from 'react-async-hook';
import { fetchListByBbox } from 'pages/ProjectInsights/services';
import { useCurrentRegion } from 'state/currentRegion';
import type { PaginatedProject } from 'types/index';

type ProjectsByBboxProps = {
  bbox: string | null | undefined;
  searchByRegion?: boolean;
  pageSize?: number;
};

export const useProjectsByBbox = ({ bbox, pageSize = 5 }: ProjectsByBboxProps) => {
  const { currentRegion } = useCurrentRegion();
  const getProjectCards = useAsyncCallback(fetchListByBbox);
  const [page, setPage] = useState(1);

  useEffect(() => {
    if (bbox && !getProjectCards.loading) {
      getProjectCards.execute(bbox, page, currentRegion, pageSize);
    } else {
      getProjectCards.reset();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bbox, page]);

  useEffect(() => {
    // Reset the page setting whenever the polygon changes
    setPage(1);
  }, [bbox]);

  return useMemo(() => {
    return {
      projects: getProjectCards.result?.projects as PaginatedProject[],
      isLoading: getProjectCards.loading,
      error: getProjectCards.error,
      nextPage: getProjectCards.result?.nextPage,
      count: getProjectCards.result?.count,
      setPage,
      page,
    };
  }, [getProjectCards, page]);
};
